function NotFound() {
  return (
    <>
      <h2>Error 404 : Page non trouvé</h2>
    </>
  );
}

export default NotFound;
